var _defs, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 361.03 73.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #808285;\n        font-family: AdobeClean-Bold, 'Adobe Clean';\n        font-size: 68px;\n        font-weight: 700;\n      }\n\n      .cls-2 {\n        letter-spacing: 0em;\n      }\n\n      .cls-3 {\n        letter-spacing: 0em;\n      }\n\n      .cls-4 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-5 {\n        letter-spacing: .01em;\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n\n      .cls-8 {\n        letter-spacing: 0em;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 56.64) scale(.69 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 44.13,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 68.47,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 105.87,
    y: 0
  }, "ce"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 169.32,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 193.59,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 210.45,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 245.47,
    y: 0
  }, "s &amp; "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 351.08,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 384.87,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 441.38,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 478.98,
    y: 0
  }, "G"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature1.6f52ee2df39b490d7a1c6db7e784f7e4.svg";
export { ForwardRef as ReactComponent };